import { markSpeechEnd, markSpeechStart, markSpeechWord } from './voiceSignal';
import { db } from './db';
import { voices as voiceProfiles } from '../data/beheer/persona';

/** The voice chosen in Beheer → Anna → Stem shapes pitch and pace of every spoken line. */
function activeProfile() {
  const id = db.getState().settings.voiceId;
  return voiceProfiles.find((v) => v.id === id) ?? voiceProfiles[0];
}

/** Dutch text-to-speech via the browser. Returns false when unavailable. */
export function speakDutch(text: string, options: { volume?: number; onEnd?: () => void; voiceId?: string } = {}): boolean {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return false;
  const synth = window.speechSynthesis;
  synth.cancel();
  const profile = (options.voiceId && voiceProfiles.find((v) => v.id === options.voiceId)) || activeProfile();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'nl-NL';
  utterance.rate = profile.rate;
  utterance.pitch = profile.pitch;
  utterance.volume = options.volume ?? 1;
  const voices = synth.getVoices().filter((v) => v.lang?.toLowerCase().startsWith(profile.id === 'ronnie' ? 'nl-be' : 'nl'));
  const fallback = synth.getVoices().filter((v) => v.lang?.toLowerCase().startsWith('nl'));
  const pool = voices.length ? voices : fallback;
  const preferred = pool.find((v) => /natural|google|neural/i.test(v.name)) ?? pool[0];
  if (preferred) utterance.voice = preferred;
  utterance.onstart = () => markSpeechStart();
  utterance.onboundary = (e) => {
    if (e.name && e.name !== 'word') return;
    const length = e.charLength || (text.slice(e.charIndex).match(/^\S+/)?.[0].length ?? 5);
    markSpeechWord(length);
  };
  const finish = () => {
    markSpeechEnd();
    options.onEnd?.();
  };
  utterance.onend = finish;
  utterance.onerror = finish;
  synth.speak(utterance);
  return true;
}

export function cancelSpeech() {
  markSpeechEnd();
  if (typeof window !== 'undefined' && 'speechSynthesis' in window) window.speechSynthesis.cancel();
}
